import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const CheckInDialog = ({ open, close }) => {
  return (
    <Dialog
      open={open}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"You are checked in!"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText >
          When the event starts, come back here and click on the 'Start Event' button 
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Got it</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CheckInDialog;
